import React from 'react';
import {useParams} from 'react-router-dom';
import { SkeletonForm } from 'src/Components/Form/SkeletonForm';
import {EditeGlobalUser} from './EditeGlobalUser';
import {Auth0User} from '../../../../Actions/Users/UsersDomain';
import {useParameterizedQuery} from 'react-fetching-library';
import {getGlobalUser, updateGlobalUser} from '../../../../Actions/Users/UsersActions';
import {addAlert} from '../../../../Context/AlertProvider/AlertProviderActions';
import {useAlertDispatcherState} from '../../../../Context/AlertProvider/AlertProvider';

interface ViewProps {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
}

export const EditeGlobalUserTabElement: React.FunctionComponent<ViewProps> = (props) =>{
    const {isLoading, setIsLoading} = props;
    const { userID, tabKey } = useParams();

    const [globalUser, setGlobalUser] = React.useState<Auth0User>();
    const [isLoaded, setIsLoaded] = React.useState<boolean>();

    const getGlobalUserAction = useParameterizedQuery(getGlobalUser);
    const updateGlobalUserAction = useParameterizedQuery(updateGlobalUser);

    const alertDispatcher = useAlertDispatcherState();

    const updateGlobalHandler = React.useCallback( (userToUpdate:Auth0User) => {
        if( userID !== undefined ){
            updateGlobalUserAction.query({id:userID, user:userToUpdate}).then( r =>{
                if ( r.payload && !r.payload.error['has-error'] ){
                    addAlert('OK', r.payload.response, 'success', alertDispatcher);
                    setIsLoaded(false);
                }
            } );
        }
    }, [alertDispatcher, updateGlobalUserAction, userID] );

    React.useEffect( ()=>{
        if( userID !== undefined && isLoaded !==undefined && !isLoaded && !getGlobalUserAction.loading){
            setIsLoaded(true);
            getGlobalUserAction.query({id: userID}).then(r => {
                if ( r.payload && !r.payload.error['has-error'] ){
                    setGlobalUser( r.payload.response );
                }
            });
        }
    }, [getGlobalUserAction, isLoaded, userID]);

    React.useEffect( ()=>{
        setIsLoading(getGlobalUserAction.loading || updateGlobalUserAction.loading);
    }, [getGlobalUserAction, setIsLoading, updateGlobalUserAction.loading] );

    React.useEffect( ()=>{
        if(tabKey === undefined){
            setIsLoaded(undefined);
            return;
        }

        setIsLoaded( !( tabKey === 'usuario-global' ) );
        setGlobalUser( undefined );
    }, [tabKey] );


    if (isLoading){
        return <SkeletonForm largeInputs={0} middleInputs={3} buttons={2} />;
    }

    return <EditeGlobalUser globalUser={globalUser} setIsLoaded={setIsLoaded} updateHandler={updateGlobalHandler}/>;
};
